module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "letter1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("From: Len.Spinks@jfmayhewoffice.co.uk")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "letter"
  }, [_vm._v("To: Gina.Almonza@SouthCountiesMagazine.com")]), _vm._v(" "), _c('p', {
    staticClass: "letterb"
  }, [_vm._v("Subject: Sophie Mayhew Article—Editorial Control Suggestions")]), _vm._v(" "), _c('p', {
    staticClass: "letterb"
  }, [_vm._v("Dear Gina,")]), _vm._v(" "), _c('p', {
    staticClass: "letterb"
  }, [_vm._v("Thank you for the draft article on Mrs. Mayhew entitled “Sophie at Home.”")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("A few amendments, additions, and deletions to consider then implement.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_vm._v("1. Mrs. Mayhew smiles as she greets me; "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("warmth is perhaps not a word associated with her, but")]), _vm._v(" "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("her handshake is firm and friendly.")])]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_vm._v("2. The reception room is wall-to-wall taste with its cool pastel walls and sumptuous carpet. "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("The furniture is more reflective of style than comfort. It is all too perfect, suggesting some deliberate artistic composition.")]), _vm._v(" !!!!! "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("The furniture is stylish and beautiful, rather like Mrs. Mayhew herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_vm._v("3. End the article after “New York,” see below.")])]), _c('p', {
    staticClass: "order-noind"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("After the tour of her fabulous house, I ask Mrs. Mayhew over tea what her dream is and she gives me a measured reply: to be by her husband’s side as a support because she has put her dreams with his, which reminds me somewhat sweetly of the lyrics of ")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("“Fairytale of New York.” "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("I’m not convinced. There is more to Mrs. Mayhew than as a mere appendage to her super-successful husband, much more I suspect, but sadly I’m not going to get the true answer today.")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "letterb"
  }, [_vm._v("And I think we will go with an alternative title: "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("The Magnificent Mrs. Mayhew.")])]), _vm._v(" "), _c('p', {
    staticClass: "letterb"
  }, [_vm._v("Alliterative and entirely fitting to Sophie, the adjective “Magnificent” has slightly old-fashioned yet fond and glamorous connotations—see: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Magnificent")]), _vm._v(" Obsession, The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Magnificent")]), _vm._v(" Seven, Those "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Magnificent")]), _vm._v(" Men in their Flying Machines. It is a word less used these days, and for that reason stands out in the best way.")]), _vm._v(" "), _c('p', {
    staticClass: "letterb"
  }, [_vm._v("We are good to go once these have been incorporated into your article. Please send amended copy forthwith for final read-through.")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Yours truly,")]), _vm._v(" "), _c('p', {
    staticClass: "letterb"
  }, [_vm._v("Len Spinks")]), _vm._v(" "), _c('p', {
    staticClass: "letter"
  }, [_vm._v("Senior Communications Director and Press Officer to John F. Mayhew, Secretary of State for Family Matters.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e1940b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 75
// module chunks = 0